import { Injectable } from '@angular/core';
import {
  IQueueEntry,
  TrackJsErrorLogService
} from '@legalzoom/business-formation-sdk';
import { HttpErrorResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { ProductName } from '../constants/product-domain';
import { OrderService as SdkOrderService } from '@legalzoom/order-sdk';
@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(private sdkOrderService: SdkOrderService, private trackJsErrorLogService: TrackJsErrorLogService ) { }
  prepareGetOrderById(context: any, appService: any, orderId: number, customerId: number, authToken: string, productName: ProductName): IQueueEntry {
    const that = this;
    return {
      name: 'prepareGetOrderById order.service' + context.constructor.name,
      pre: () => {
        return that.sdkOrderService.getOrdersById(orderId, customerId);
      },
      post: (response) => {
        const appState = appService.app;
        if (!!response) {
          appState.orderId = response.order.orderId;
          context.order = response.order;
        } else {
          appState.orderId = 0;
        }
        appService.app = appState;
      },
      error: (error: HttpErrorResponse) => {
        console.log(error.message);
        this.trackJsErrorLogService.track(productName, 'order.service' + context.constructor.name, error);
        return of(null);
      }
    };

  }
}
